#import "@/apollo/fragments/ClientUploadConfig.gql"
#import "@/apollo/fragments/MediaItem.gql"

query MediaItems($clientId: ID!, $folderId: ID, $orderBy: EnumMediaItemOrderBy) {
    client(id: $clientId) {
        id
        ...ClientUploadConfig
    }
    folderBreadCrumbs(clientId: $clientId, folderId: $folderId)
    mediaItems(clientId: $clientId, folderId: $folderId, orderBy: $orderBy) {
        ...MediaItem
    }
}
